<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="海图系统" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 项目介绍 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目介绍"></main-title>
        <retract-list :dataList="introduceList"></retract-list>
      </div>
    </section>

    <!-- 产品核心功能 -->
    <section class="d-flex align-items-center pt-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="产品核心功能"></main-title>
        <div class="indentation pb-3">
          <desc-list :dataList="lightSpotList"></desc-list>
        </div>
        <div class="lg-hidden">
          <h1 class="title-h1 font-weight-bold text-align-center pb-2">海图App</h1>
          <p class="title-h2 text-align-center pb-3">页面展示</p>
        </div>
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/hlx/app.png" />
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/hlx/app.png" />
          <img src="@/assets/img/lg/hlx/app.png" class="image-width-100" />
        </picture>
        <div class="lg-hidden">
          <h1 class="title-h1 font-weight-bold text-align-center pb-2 pt-3">海图网页端</h1>
          <p class="title-h2 text-align-center pb-3">页面展示</p>
        </div>
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/hlx/pc.png" />
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/hlx/pc.png" />
          <img src="@/assets/img/lg/hlx/pc.png" class="image-width-100 pb-4" />
        </picture>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'Ehs',
  components: { Swiper,},
  props: {},
  data() {
    return {
      bannerList: [{ src: require('@/assets/img/common/caseList/hlx/banner1.png') }, { src: require('@/assets/img/common/caseList/hlx/banner2.png') }],
      // 项目背景
      projectList: ['海事监管系统是一款用于监控海上船舶的信息系统。主要通过AIS，雷达，光电扫描海上航行船舶，获取船舶信息。大数据平台推送数据，监控海上违法船只，为海上执法提供依据。'],
      // 项目介绍
      introduceList: [
        ' 该项目主要由PC端和移动APP组成。PC端主要用来监管船舶，通过无人机，无人船 发送指令，及时救援，捕捉海上非法船只。移动APP方便执法者操作，通过手机端可快速查看信息，及时反馈船只最新状态，为移动办公提供极大便捷。',
      ],
      // 产品核心功能
      lightSpotList: [
        {
          title: '海图展示：',
          titleDetail: '主要包含海图，地图，卫星图，海图地图，海图卫星图等多种切换。',
        },
        {
          title: '船只绘制：',
          titleDetail: '通过大数据返回的船舶信息，绘制船舶信息。',
        },
        {
          title: '航行轨迹：',
          titleDetail: '海图上绘制船只航行实时轨迹，历史轨迹。',
        },
        {
          title: '光电随动：',
          titleDetail: '光电监控船只，提供违法拍照视频。',
        },
        {
          title: '船只救援：',
          titleDetail: '操控无人机，为现场救援提供实时视频。',
        },
        {
          title: '问题反馈：',
          titleDetail: '现场人员通过手机反馈信息，及时调整救援任务。',
        },
      ],
    }
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
}
</script>
<style scoped></style>
